export default "__VITE_ASSET__05a082a5__"